<script setup>
import { ref } from 'vue'
import { useWebSiteStore } from '@/stores/web-site.store'

const webSiteStore = useWebSiteStore()

const props = defineProps({
  delay: {
    type: Number,
    default: 250
  },
  data: {
    type: Array,
    required: true,
    validator: function(value) {
      return value.every(item => item.hasOwnProperty('key') && item.hasOwnProperty('value'))
    }
  },
  options: {
    type: Object,
    default: () => ({})
  },
})

const isMobile = !webSiteStore.platform.is.desktop
const defaultAnchor = 'bottom middle'

const showMobileInfo = ref(isMobile)
if (props.options?.showMobileInfo !== undefined) {
  showMobileInfo.value = props.options.showMobileInfo
}
const showColor = ref(false)
if (props.options?.showColor !== undefined) {
  showColor.value = props.options.showColor
}

</script>
<template>
  <q-icon
    v-if="showMobileInfo"
    name="mdi-information"
    :color="props.color || 'primary'"
    size="xs"
    style="margin-left: .25rem;"
    @contextmenu.prevent
  />
  <q-tooltip
    v-if="props.data"
    :anchor="options?.anchor || defaultAnchor"
    :delay="props.delay"
    self="top middle"
    style="background-color: transparent"
  >
    <q-card
      class="shadow-5 no-border-radius"
    >
      <q-markup-table
        :style="options?.minWidth ? { minWidth: options.minWidth } : {}"
      >
        <tbody>
          <tr
            v-for="(item, index) in props.data"
            :key="index"
          >
            <template v-if="item.isLabel">
              <td class="text-left text-bold bg-gray-100 py-2">
                {{ item.value }}
              </td>
            </template>
            <template v-else>
              <td
                v-if="!props?.options?.noKey"
                :class="['text-left table-cell', item.bold ? 'text-bold' : '']"
              >
                {{ item.key }}
              </td>
              <td :class="['text-right table-cell', item.bold ? 'text-bold' : '']">
                <div
                  :class="['flex items-center', !props?.options?.noKey ? 'justify-end' : '']"
                >
                  <div
                    v-if="item.color && showColor"
                    class="color-box"
                    :style="{ backgroundColor: item.color }"
                  />
                  <span>{{ item.value }}</span>
                </div>
              </td>
            </template>
          </tr>
        </tbody>
      </q-markup-table>
    </q-card>
  </q-tooltip>
</template>

<style scoped lang="scss">
  .custom-width {
    min-width: 250px;
  }

  .no-border-radius {
    border-radius: 0 !important;
  }

  .group-title {
    color: $primary;
    font-weight: bold;
  }

  .table-cell {
    height: 2.25rem;
  }

  .color-box {
    width: 1rem;
    height: 1rem;
    border-radius: 0.25rem;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    border: 1px solid #ccc;
  }
</style>
